// @flow
/* eslint-disable no-shadow */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import { withTranslation } from 'react-i18next';
import { isMobile, getOS } from '../../utils';
import { styles } from '../../modules/scribe/SidebarHelpers';
import AvaLogoSphere from '../../../assets/images/ava_logo_sphere.png';

function OpenOrDownloadAva({
  classes,
  t,
  setOpenOrDownloadAvaApp,
}: {
  classes: Object,
  t: Object,
  setOpenOrDownloadAvaApp: Function,
}) {
  const handleOpenOrDownloadAvaApp = () => {
    setOpenOrDownloadAvaApp(false);
    setTimeout(() => {
      setOpenOrDownloadAvaApp(true);
    }, 0);
  };

  const OS = getOS();

  if (window.isElectron) {
    return null;
  }
  return (
    <>
      <ListItem
        button
        key="app-bridge"
        classes={{
          focused: classes.root,
        }}
        onClick={() => handleOpenOrDownloadAvaApp()}
      >
        <ListItemIcon>
          <img src={AvaLogoSphere} style={{ height: 24 }} alt="Ava logo" />
        </ListItemIcon>
        <ListItemText
          classes={{ root: classes.listItemText }}
          primary={isMobile() ? t('sidebar.openAva') : t('sidebar.openAvaDesktop', { OS })}
        />
      </ListItem>
      <Divider />
    </>
  );
}

export default withTranslation()(withStyles(styles, { withTheme: true })(OpenOrDownloadAva));
